import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_b5c312bc from 'nuxt_plugin_sentryserver_b5c312bc' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_3f65051a from 'nuxt_plugin_sentryclient_3f65051a' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_bootstrapvue_4b74d5e6 from 'nuxt_plugin_bootstrapvue_4b74d5e6' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_142ecef4 from 'nuxt_plugin_cookieuniversalnuxt_142ecef4' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuescrollto_2e16092a from 'nuxt_plugin_vuescrollto_2e16092a' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_nuxtsocketio_fb07e778 from 'nuxt_plugin_nuxtsocketio_fb07e778' // Source: ./nuxt-socket-io.js (mode: 'all')
import nuxt_plugin_recaptcha_2333644d from 'nuxt_plugin_recaptcha_2333644d' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_b5ef1644 from 'nuxt_plugin_axios_b5ef1644' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_068f2a7a from 'nuxt_plugin_workbox_068f2a7a' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_a88950e6 from 'nuxt_plugin_metaplugin_a88950e6' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_9f3a05fe from 'nuxt_plugin_iconplugin_9f3a05fe' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_moment_0ab1b87a from 'nuxt_plugin_moment_0ab1b87a' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_common_25e198df from 'nuxt_plugin_common_25e198df' // Source: ../plugins/common (mode: 'all')
import nuxt_plugin_helper_2ddc7ea2 from 'nuxt_plugin_helper_2ddc7ea2' // Source: ../plugins/helper (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_bootstrap_29b38afa from 'nuxt_plugin_bootstrap_29b38afa' // Source: ../plugins/bootstrap (mode: 'all')
import nuxt_plugin_filters_2abc1387 from 'nuxt_plugin_filters_2abc1387' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_localstorage_6bbb00a5 from 'nuxt_plugin_localstorage_6bbb00a5' // Source: ../plugins/local-storage (mode: 'all')
import nuxt_plugin_vuetelinput_350602c6 from 'nuxt_plugin_vuetelinput_350602c6' // Source: ../plugins/vue-tel-input (mode: 'client')
import nuxt_plugin_vueotpinput_30d65d2a from 'nuxt_plugin_vueotpinput_30d65d2a' // Source: ../plugins/vue-otp-input.js (mode: 'client')
import nuxt_plugin_fontawesome_999c0e4e from 'nuxt_plugin_fontawesome_999c0e4e' // Source: ../plugins/font-awesome (mode: 'client')
import nuxt_plugin_vuecarousel_50c44c8a from 'nuxt_plugin_vuecarousel_50c44c8a' // Source: ../plugins/vue-carousel (mode: 'client')
import nuxt_plugin_vueresponsive_c9901962 from 'nuxt_plugin_vueresponsive_c9901962' // Source: ../plugins/vue-responsive (mode: 'client')
import nuxt_plugin_vueswal_15cfef6a from 'nuxt_plugin_vueswal_15cfef6a' // Source: ../plugins/vue-swal (mode: 'client')
import nuxt_plugin_vueplyr_15ce6bf0 from 'nuxt_plugin_vueplyr_15ce6bf0' // Source: ../plugins/vue-plyr (mode: 'client')
import nuxt_plugin_vueclipper_4b324ca5 from 'nuxt_plugin_vueclipper_4b324ca5' // Source: ../plugins/vue-clipper.js (mode: 'client')
import nuxt_plugin_vuegtag_15ca6fae from 'nuxt_plugin_vuegtag_15ca6fae' // Source: ../plugins/vue-gtag (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Praktek Online Dr Spesialis","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"title","name":"title","content":"Praktek Online Dr Spesialis"},{"hid":"keywords","name":"keywords","content":"YesDok,konsultasi,tanyadokter,dokter,Dokter24Jam,DokterBeneran"},{"hid":"description","name":"description","content":"Dengan video call terbaik di dunia! Daftar gratis!"},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fydbucketstorage.s3.ap-southeast-1.amazonaws.com\u002Fimg\u002Fv3\u002Fmain\u002Ffavicon.ico?"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5bbad5"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_b5c312bc === 'function') {
    await nuxt_plugin_sentryserver_b5c312bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_3f65051a === 'function') {
    await nuxt_plugin_sentryclient_3f65051a(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_4b74d5e6 === 'function') {
    await nuxt_plugin_bootstrapvue_4b74d5e6(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_142ecef4 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_142ecef4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_2e16092a === 'function') {
    await nuxt_plugin_vuescrollto_2e16092a(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsocketio_fb07e778 === 'function') {
    await nuxt_plugin_nuxtsocketio_fb07e778(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_2333644d === 'function') {
    await nuxt_plugin_recaptcha_2333644d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b5ef1644 === 'function') {
    await nuxt_plugin_axios_b5ef1644(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_068f2a7a === 'function') {
    await nuxt_plugin_workbox_068f2a7a(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_a88950e6 === 'function') {
    await nuxt_plugin_metaplugin_a88950e6(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_9f3a05fe === 'function') {
    await nuxt_plugin_iconplugin_9f3a05fe(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_0ab1b87a === 'function') {
    await nuxt_plugin_moment_0ab1b87a(app.context, inject)
  }

  if (typeof nuxt_plugin_common_25e198df === 'function') {
    await nuxt_plugin_common_25e198df(app.context, inject)
  }

  if (typeof nuxt_plugin_helper_2ddc7ea2 === 'function') {
    await nuxt_plugin_helper_2ddc7ea2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrap_29b38afa === 'function') {
    await nuxt_plugin_bootstrap_29b38afa(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2abc1387 === 'function') {
    await nuxt_plugin_filters_2abc1387(app.context, inject)
  }

  if (typeof nuxt_plugin_localstorage_6bbb00a5 === 'function') {
    await nuxt_plugin_localstorage_6bbb00a5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetelinput_350602c6 === 'function') {
    await nuxt_plugin_vuetelinput_350602c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueotpinput_30d65d2a === 'function') {
    await nuxt_plugin_vueotpinput_30d65d2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontawesome_999c0e4e === 'function') {
    await nuxt_plugin_fontawesome_999c0e4e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_50c44c8a === 'function') {
    await nuxt_plugin_vuecarousel_50c44c8a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueresponsive_c9901962 === 'function') {
    await nuxt_plugin_vueresponsive_c9901962(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueswal_15cfef6a === 'function') {
    await nuxt_plugin_vueswal_15cfef6a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueplyr_15ce6bf0 === 'function') {
    await nuxt_plugin_vueplyr_15ce6bf0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclipper_4b324ca5 === 'function') {
    await nuxt_plugin_vueclipper_4b324ca5(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegtag_15ca6fae === 'function') {
    await nuxt_plugin_vuegtag_15ca6fae(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
